type PreviewBookingModule = typeof import('@/modules/profile/components/PreviewBooking');

let previewBooking: PreviewBookingModule | null = null;

/** The preview booking module, once `preloadProfileAsideCode` loaded it (sync: a tap must not wait). */
export const loadedPreviewBooking = (): PreviewBookingModule | null => previewBooking;

/**
 * Loads the profile aside's lazy chunks ahead of the navigation (pause on / tap of a search card).
 * With the booking data prefetched, these chunks were the only thing the booking card still waited
 * for after the profile committed (`asideChunksReady`, docs/performance.md §۳.۱۸). The same load
 * brings the navigation preview's real booking card (`PreviewBooking`, §۳.۱۹). Code only: no requests
 * to APIs, no analytics. Dynamic import, so the search page's own bundle does not grow.
 */
export function preloadProfileAsideCode(): Promise<void> {
  return import('@/modules/profile/components/PreviewBooking')
    .then(m => {
      previewBooking = m;
      return import('@/modules/profile/views/aside');
    })
    .then(m => m.preloadAsideChunks())
    .catch(() => undefined);
}
